import { request } from '@/fetch/core';

export class VehicleInitialDetailFetch {
  public getDetail = (params: { vehicleName: string }) => {
    const requestParams: RequestOptions = {
      path: `/monitor/web/report/boot`,
      method: 'POST',
      body: {
        vehicleName: params.vehicleName,
      },
    };
    return request(requestParams);
  };
}
